export default {
  VIEWS: {
    INITIAL: 'Initial',
    ENTER_BILLING_INFORMATION: 'Enter billing information',
    CHECKOUT: 'Checkout',
    SUCCESS: 'Success'
  }
};
